import PeriprocedureelBeleidTARDaptAsaDip from "../../../../src/client/lta-antistolling/periprocedureel-beleid-tar-dapt-asa-dip.json";
import * as React from 'react';
export default {
  PeriprocedureelBeleidTARDaptAsaDip,
  React
};